/** Public config only (spec Appendix C) — injected by @studyward/config/public-env. Secrets never reach the bundle. */
export const env = {
  supabaseUrl: import.meta.env.PUBLIC_SUPABASE_URL as string,
  supabaseAnonKey: import.meta.env.PUBLIC_SUPABASE_ANON_KEY as string,
  siteUrl: (import.meta.env.PUBLIC_SITE_URL as string) || "http://localhost:4321",
  /** RevenueCat Web Billing public key (rcb_…); empty until the owner sets up Web Billing (§15 #5). */
  revenuecatWebKey: (import.meta.env.PUBLIC_REVENUECAT_WEB_KEY as string) || "",
};

/** True when the Supabase values are filled in; the app shows a setup message otherwise. */
export const isConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);

export const apiBaseUrl = `${env.supabaseUrl}/functions/v1/api/v1`;

/** Where Supabase sends people back after email links and Google/Apple sign-in. */
export const authCallbackUrl = () => `${window.location.origin}/auth/callback`;
